import axios from "axios";

let endpoint = "https://api.dahrujrentacar.com.br/api/";
if (process.env.NODE_ENV === "development") { endpoint = "https://localhost:44349/api/"; }

const http = axios.create({
  baseURL: endpoint,
});

export default http;